export default __webpack_public_path__ + "static/media/gallery_09.b6f7b4d0.jpg";